"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkHealthBufferedDispatcher = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NetworkHealthBufferedDispatcher = exports.NetworkHealthBufferedDispatcher = /*#__PURE__*/function () {
  function NetworkHealthBufferedDispatcher(dispatch, setAttendeeNetworkHealth) {
    _classCallCheck(this, NetworkHealthBufferedDispatcher);
    _defineProperty(this, "bufferedData", {});
    this.dispatch = dispatch;
    this.setAttendeeNetworkHealth = setAttendeeNetworkHealth;
    this.startDispatchWorker();
  }
  return _createClass(NetworkHealthBufferedDispatcher, [{
    key: "updateNetworkHealthData",
    value: function updateNetworkHealthData(attendeeId, uploadBandwidth, downloadBandwidth, audioPacketLoss, audioJitter, audioLatency, audioMOS, videoPacketLoss, videoJitter, videoLatency, videoMOS, videoFrame, networkQuality) {
      if (!this.bufferedData[attendeeId]) {
        this.bufferedData[attendeeId] = {};
      }
      Object.assign(this.bufferedData[attendeeId], {
        uploadBandwidth: uploadBandwidth,
        downloadBandwidth: downloadBandwidth,
        audioPacketLoss: audioPacketLoss,
        audioJitter: audioJitter,
        audioLatency: audioLatency,
        audioMOS: audioMOS,
        videoPacketLoss: videoPacketLoss,
        videoJitter: videoJitter,
        videoLatency: videoLatency,
        videoMOS: videoMOS,
        videoFrame: videoFrame,
        networkQuality: networkQuality
      });
    }
  }, {
    key: "updateReceivedFrameData",
    value: function updateReceivedFrameData(attendeeId, receivedFrame) {
      if (!this.bufferedData.hasOwnProperty(attendeeId)) {
        this.bufferedData[attendeeId] = {};
      }
      this.bufferedData[attendeeId]['receivedFrame'] = receivedFrame;
    }
  }, {
    key: "startDispatchWorker",
    value: function startDispatchWorker() {
      var _this = this;
      setInterval(function () {
        _this.dispatch(_this.setAttendeeNetworkHealth(_this.bufferedData));
        _this.bufferedData = {};
      }, 3000);
    }
  }], [{
    key: "initialize",
    value: function initialize(dispatch, setAttendeeNetworkHealth) {
      if (!NetworkHealthBufferedDispatcher.instance) {
        NetworkHealthBufferedDispatcher.instance = new NetworkHealthBufferedDispatcher(dispatch, setAttendeeNetworkHealth);
      }
    }
  }]);
}();
_defineProperty(NetworkHealthBufferedDispatcher, "instance", null);